"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driversLicense = void 0;
const enums_1 = require("@bemlo/enums");
exports.driversLicense = {
    [enums_1.DriversLicense.MANUAL]: 'Førerkort på manuelt gir',
    [enums_1.DriversLicense.AUTOMATIC]: 'Førerkort på automatgir',
    [enums_1.DriversLicense.NONE]: 'Ingen førerkort',
};
